import { Action, createReducer, on } from '@ngrx/store';
import { DashboardStateModel } from '@platform/dashboard/models/dashboard-state.model';
import * as DashboardActions from './dashboard.actions';

export const dashboardInitialState: DashboardStateModel = {
  selectedAdviserUserEmail: null,
  filter: {
    networkIds: [],
    advisorUsersIdsWrapper: {
      advisorUserIds: null,
    },
    companyIdsWrapper: {
      companyIds: null,
    },
  },
};

const reducer = createReducer(
  dashboardInitialState,
  on(
    DashboardActions.setDashboardFilter,
    (state, { filter }): DashboardStateModel => ({
      ...state,
      filter,
    }),
  ),

  on(
    DashboardActions.resetDashboardFilters,
    (state): DashboardStateModel => ({
      ...state,
      filter: {
        companyIdsWrapper: {
          companyIds: null,
        },
        advisorUsersIdsWrapper: {
          advisorUserIds: null,
        },
        networkIds: [],
      },
    }),
  ),

  on(
    DashboardActions.setSelectedAdviserEmail,
    (state, { selectedAdviserUserEmail }): DashboardStateModel => ({
      ...state,
      selectedAdviserUserEmail,
    }),
  ),
);

export const dashboardReducer = (state: DashboardStateModel = dashboardInitialState, action: Action): DashboardStateModel =>
  reducer(state, action);
